// extracted by mini-css-extract-plugin
export default {"TagSelect":"MultiSelect_TagSelect__UHWrk","prefix":"MultiSelect_prefix__20xWf"};